import PropTypes from "prop-types";
import AlignedImageBox2 from "../../../components/image-boxes/aligned-image-box/aligned-image-box-2";
import { nairaFormart } from "../../../utils/functions";

const PropertyHistoryList = ({ data, myUid }) => {
  return (
    <div className="w-full overflow-x-auto pb-4">
      <div className="min-w-[800px] divide-y divider-black">
        <div className="table-header flex font-semibold header-font text-[14px] gap-4 pb-2">
          <div className="w-[30%]">Property</div>
          <div className="w-[20%]">Method</div>
          <div className="w-[20%]">Amount</div>
          <div className="w-[20%] text-center">Status</div>
        </div>
        {data.map((item, index) => {

          const metadata = item.metadata || {};
          const title = metadata.title || "Ruumies Property";
          const price = item.amount || 0;
          const status = item.escrowStatus || "Completed";
          
          const isOwnerForThisTx = item.receiverID === myUid;
          
          return (
            <div
              key={index}
              className="table-header flex font-light gap-4 items-center text-[14px] w-full py-4"
            >
              <div className="w-[30%]">
                <AlignedImageBox2
                  profileImage={item.customer?.metadata?.media || metadata.media || null}
                  text={title}
                  subtext={isOwnerForThisTx ? "Income" : "Payment"}
                />
              </div>
              <div className="w-[20%] capitalize">{item.channel || "Card"}</div>
              <div className={`w-[20%] font-medium ${isOwnerForThisTx ? "text-green-600" : "text-red-500"}`}>
                {isOwnerForThisTx ? "+" : "-"}{nairaFormart(price)}
              </div>
              <div className="w-[20%] text-center">
                <span className={`py-1 px-3 rounded-2xl text-[10px] sm:text-xs whitespace-nowrap ${status === 'Held' ? 'text-yellow-700 bg-yellow-100' : 'text-green-700 bg-green-200'}`}>
                  {status === 'Held' ? 'Awaiting Move-In' : status === 'Move_In_Confirmed' ? 'Confirmed' : 'Successful'}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

PropertyHistoryList.propTypes = {
  data: PropTypes.array.isRequired,
  confirmMoveIn: PropTypes.func.isRequired,
  myUid: PropTypes.string.isRequired,
};

export default PropertyHistoryList;